import { PriceDetails } from 'shared/types/checkout';
import { centsToDollarStringFormatted } from 'utils/price';

/**
 * Calculate discount display text (absolute value or percentage)
 */
export const calculateDiscountAmount = (
  cartDiscount: PriceDetails['cartDiscount'],
  formatter: typeof centsToDollarStringFormatted,
): string => {
  if (!cartDiscount?.discount) {
    return '';
  }

  if (cartDiscount.discount.type === 'absolute') {
    const value = formatter(
      cartDiscount.discount.value?.[0]?.centAmount ?? 0,
      cartDiscount.discount.value?.[0]?.fractionDigits ?? 2,
    );
    return `${value}`;
  }

  const percentage = cartDiscount.percent ?? '';
  return `${percentage}%`;
};
